const compare = require('./compare')
const lt = (a, b, loose) => compare(a, b, loose) < 0
module.exports = lt



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/lt.js
// module id = 381
// module chunks = 0